import { RouterProvider } from "@tanstack/react-router";

import { LoadingScreen } from "~/components/loading_screen";
import { Unauthorized } from "~/components/unauthorized";
import { useAuthQueryFactoryInternal } from "~/contexts/auth_query";
import { AuthQueryProvider } from "~/providers/auth_query";
import { ConfigProvider } from "~/providers/config";
import { NotificationsProvider } from "~/providers/notifications";
import { ThemeProvider } from "~/providers/theme";
import { theme } from "~/theme";
import { config } from "~root/config";

import { router } from "./router";

export function App() {
  const authResult = useAuthQueryFactoryInternal({
    api: config.api,
    auth: config.auth,
  });

  const { authValue: auth } = authResult;

  if (auth.status === "unauthenticated") {
    return null;
  }

  return (
    <ConfigProvider config={config}>
      <AuthQueryProvider authResult={authResult}>
        <ThemeProvider theme={theme}>
          <NotificationsProvider>
            {auth.status === "loading" ? (
              <LoadingScreen />
            ) : auth.status === "unauthorized" ? (
              <Unauthorized
                logout={auth.logout}
                supportEmail={config.supportEmail}
              />
            ) : (
              <RouterProvider router={router} context={auth} />
            )}
          </NotificationsProvider>
        </ThemeProvider>
      </AuthQueryProvider>
    </ConfigProvider>
  );
}
